import React from 'react';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { MonthlyPresenceCard } from './MonthlyPresenceCard';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';

export class MonthlyPresenceScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_PRESENCES_MONTHLY,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_LISTERIA_MENSUAL')} breadcrumbs={breadcrumbs}>
                <MonthlyPresenceCard/>
            </PsPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/MonthlyPresenceScreen.jsx